module.exports = __webpack_public_path__ + "img/icon-image.66ffe813.png";